import { useEffect } from 'react';
import { useNoticeBannersStackContext } from '@sweetgreen/garnish';

export const usePermanentNoticeBanner = (visibility: boolean, text: string) => {
  const { push: addNoticeBanner, pop: removeNoticeBanner } =
    useNoticeBannersStackContext();

  useEffect(() => {
    if (!visibility) return;

    addNoticeBanner(
      {
        text,
        palette: 'success',
        autoHideTimeout: 'never',
        onClose: removeNoticeBanner,
      },
      true,
    );

    return () => {
      removeNoticeBanner();
    };
  }, [visibility, text, addNoticeBanner, removeNoticeBanner]);

  return { dismiss: removeNoticeBanner };
};
